import logo from '../../assets/images/Qi4M_Logo.svg';

const Footer = () => {
  return (
    <footer className="bg-textPrimary text-white ">
      <div className="container mx-auto flex items-center justify-between px-4">
        {/* Spazio vuoto per mantenere centrata la p */}
        <div className="w-1/3 flex justify-start" />

        {/* Testo centrale */}
        <div className="w-1/3 text-center">
          <p className="text-sm font-paragraph">
            © {new Date().getFullYear()} QI4M - Tutti i diritti riservati.
          </p>
        </div>
        {/* Logo a destra */}
        <div className="w-1/3 flex justify-end">
          <img src={logo} alt="Logo QI4M" className="h-24 w-auto brightness-0 invert" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
